import React from 'react'
import { TableHeadersType } from '../../../../constant/tableHeadersConstants/tableHeadersType'
import { TableHeader } from '../../../commons';
import ScrollToTop from '../../../commons/ScrollToTop';
import GeneralLedgerTableData from './GeneralLedgerTableData';
import { GeneralLedgerListDataType } from '../../../../redux/reports/reportsType';

type AppProps = {
  tableHeaders: TableHeadersType[];
  tableData: GeneralLedgerListDataType[] | [];
  clientCode: number;
  companyName: string;
  startDate: string;
  endDate: string;
  fetching: boolean;
  currencySign: string | undefined;
  isLedgerStatementPresent?:boolean;
}
const GeneraLedgerTable = ({
  tableHeaders,
  tableData,
  clientCode,
  companyName,
  startDate,
  endDate,
  currencySign,
  fetching,
  isLedgerStatementPresent
}: AppProps) => {
  return (
    <div className='jobsType table-responsive'>
      <table className='table thead-light'>
        <thead className='text-start sticky-table-header'>
          <TableHeader
            tableHeader={tableHeaders}
          />
        </thead>
        <tbody>
          <GeneralLedgerTableData
            tableHeaders={tableHeaders}
            tableData={tableData}
            clientCode={clientCode}
            companyName={companyName}
            startDate={startDate}
            endDate={endDate}
            currencySign={currencySign}
            isLedgerStatementPresent={isLedgerStatementPresent}
          />
          <div style={{ display: fetching ? "none" : "inline" }}><ScrollToTop /></div>
        </tbody>
      </table>
    </div>
  )
}

export default GeneraLedgerTable;